var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"add-to-cart-btn",attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":_vm.buttonClick}},[_c('img',{staticClass:"img-fluid",attrs:{"title":"Add to cart","src":"/ui/main/img/add_to_cart.svg","alt":"Add to cart","loading":"lazy","width":"29","height":"35"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }